const LOYALTY_THEME_KEY = {
  TIER1: 'Tier1',
  TIER2: 'Tier2',
  TIER3: 'Tier3',
};

export default LOYALTY_THEME_KEY;
